import React,{useEffect,useState} from 'react'
import {PrintContainer} from '../../styles/Print';
import { useOrderRequests } from '../../helpers/OrderRequests';
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';
export default function PrintOrders() {
  const {id} = useParams()

  const [order,setOrder]=useState([])
  const [total,setTotal]=useState(0)
  const {getOrder}=useOrderRequests()
  useEffect(() => {
    if(order.length<1){
      getOrder(id).then(async (response)=>{
        setOrder(response.data.data)
        let unit=""

        setTimeout(() => {
          window.print()
        },4000);
      })
    }
  }, [order])
  

  return (
    <PrintContainer>
      <h1>Sipariş Detayı</h1>

      {order != [] && order.order != undefined ? (
        <>
          <div className="head">
            <div className="leftHead">
              <div>
                <span>Tarih</span>
                <span>:</span>
                <span>{order.order.date}</span>
              </div>

              <div>
                <span>Sipariş No</span>
                <span>:</span>
                <span>{order.order.orderCode}</span>
              </div>

              <div>
                <span>Durum</span>
                <span>:</span>
                <span>{order.order.status}</span>
              </div>
            </div>

            <div className="rightHead">
              <h4>{JSON.parse(localStorage.getItem("customer")).title}</h4>
              <img
                onContextMenu={() => false}
                src={order.order.image}
                height={70}
              />
            </div>
          </div>
        </>
      ) : (
        <></>
      )}

      <ul>
        <li>
          <div style={{}}>Görsel</div>
          <div style={{ width: "100%", minWidth: 300 }}>Adı</div>
          <div style={{ width: 80 }}>Miktar</div>
          {/* <div style={{width: 100}}>KDV</div> */}
          <div style={{ width: 200 }}>Fiyat</div>
          <div style={{ width: 200 }}>Toplam</div>
        </li>
        {(order != [] && order.items != undefined ? order.items : []).map(
          (x) => {
            return (
              <li>
                <div>
                  <img
                    src={
                      x.image + "?random=" + Math.floor(Math.random() * 1000)
                    }
                  />
                </div>
                <div style={{ width: "100%", minWidth: 300 }}>{x.title}</div>
                <div style={{ width: 80 }}>{x.quantity}</div>
                {/* <div style={{ width: 100 }}>%{x.vatRate}</div> */}
                <div style={{ width: 200 }}>
                  {order.order.currencyUnit} {x.price.toFixed(2)}
                </div>
                <div style={{ width: 200 }}>
                  {order.order.currencyUnit} {x.totalPriceWithVat}
                </div>
              </li>
            );
          }
        )}
        <li>
          <div></div>
          <div style={{ width: "100%", minWidth: 300 }}></div>
          <div style={{ width: 80 }}></div>
          {/* <div style={{width: 100}}></div> */}
          <div style={{ width: 200 }}></div>
          <div style={{ width: 200 }}>
            Toplam :{order.order != undefined ? order.order.currencyUnit : ""}
            {order.order != undefined
              ? order.order.totalPrice.toFixed(2)
              : ""}{" "}
          </div>
        </li>
      </ul>
    </PrintContainer>
  );
}
